export const EMPLOYEE_PEERS = "employee_peers";
export const EMPLOYEE_PEERS_SUCCESS = "employee_peers_success";
export const EMPLOYEE_PEERS_FAILURE = "employee_peers_failure";
